import { render } from "./ShareSocial.vue?vue&type=template&id=94421a42&scoped=true"
import script from "./ShareSocial.vue?vue&type=script&lang=js"
export * from "./ShareSocial.vue?vue&type=script&lang=js"

import "./ShareSocial.vue?vue&type=style&index=0&id=94421a42&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94421a42"]])

export default __exports__